/* FL AJAX FILTERS - intercept facets form submit */
(function() {
  function getSectionId() {
    var fc = document.querySelector("facets-form-component[section-id]");
    return fc ? fc.getAttribute("section-id") : null;
  }

  function renderSection(url) {
    var SID = getSectionId();
    if (!SID) return;
    var g = document.querySelector(".product-grid");
    if (g) g.style.opacity = "0.4";
    var sep = url.indexOf("?") > -1 ? "&" : "?";
    fetch(url + sep + "section_id=" + SID)
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var ns = doc.querySelector("#shopify-section-" + SID);
        var cs = document.getElementById("shopify-section-" + SID);
        if (cs && ns) {
          cs.innerHTML = ns.innerHTML;
          history.pushState({}, "", url);
        }
        var g2 = document.querySelector(".product-grid");
        if (g2) g2.style.opacity = "1";
      }).catch(function() {
        var g2 = document.querySelector(".product-grid");
        if (g2) g2.style.opacity = "1";
      });
  }

  function initAjaxFilters() {
    var fc = document.querySelector("facets-form-component");
    if (!fc) return;
    var form = fc.querySelector("form");
    if (!form || form._flAjax) return;
    form._flAjax = true;

    // Intercepter submit du form
    form.addEventListener("submit", function(e) {
      e.preventDefault();
      e.stopPropagation();
      var data = new FormData(form);
      var params = new URLSearchParams(data).toString();
      var url = form.action + (params ? "?" + params : "");
      renderSection(url);
    });

    // Intercepter change sur les checkboxes (auto-submit)
    form.addEventListener("change", function(e) {
      if (e.target.type === "checkbox" || e.target.tagName === "SELECT") {
        var data = new FormData(form);
        var params = new URLSearchParams(data).toString();
        var url = form.action + (params ? "?" + params : "");
        renderSection(url);
      }
    });
  }

  // Init au load et après chaque update AJAX
  document.addEventListener("DOMContentLoaded", initAjaxFilters);
  window.addEventListener("popstate", function() {
    renderSection(window.location.href);
  });

  // Re-init si le DOM change (après un render)
  var observer = new MutationObserver(function() { initAjaxFilters(); });
  document.addEventListener("DOMContentLoaded", function() {
    var main = document.querySelector("[id^='shopify-section-template--'][id$='__main']");
    if (main) observer.observe(main, { childList: true, subtree: false });
  });
})();






/* FL — product page fixes */
(function() {
  if (!document.body.classList.contains('template-product')) return;

  function fixProductPage() {
    // 1. Header blanc sur page produit
    var header = document.querySelector('.header');
    if (header) {
      header.style.setProperty('background', '#ffffff', 'important');
      header.style.setProperty('box-shadow', '0 1px 0 #ece5dc', 'important');
    }
    // Forcer couleurs sombres sur les liens du header
    document.querySelectorAll('.header .menu-list__link, .header [class*="nav"] a').forEach(function(a) {
      a.style.setProperty('color', '#1a1008', 'important');
    });
  }

  // Au chargement + après chaque update sticky
  fixProductPage();
  document.addEventListener('DOMContentLoaded', fixProductPage);

  // Observer les changements d'attribut data-sticky-state sur header-component
  var hc = document.querySelector('header-component');
  if (hc) {
    new MutationObserver(fixProductPage).observe(hc, { attributes: true, attributeFilter: ['data-sticky-state'] });
  }
})();
